import type * as React from 'react';
import { put } from '@Domain/Api';
import assignmentScopePath from '@Application/Ai/AiConfiguration/Assignments/assignmentScopePath';
import usageSettingsSaved, {
	type UsageSettingsSavedAction,
	type UsageSettingsSavedPayload,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/usageSettingsSaved';
import usageSettingsSaveFailed, {
	type UsageSettingsSaveFailedAction,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/usageSettingsSaveFailed';
import type SaveUsageSettings from '@Application/Ai/AiConfiguration/Assignments/Commands/SaveUsageSettings';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = UsageSettingsSavedAction | UsageSettingsSaveFailedAction;

export default (command: SaveUsageSettings) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<UsageSettingsSavedPayload>(
				`${parameters.api.host}/api/${assignmentScopePath(command.scope)}/${command.usage}/settings`,
				command.toJSON(),
			);

			const action = usageSettingsSaved(payload, command.scope);
			dispatch(action);
			return action;
		} catch (error) {
			const action = usageSettingsSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
